<template>
  <delivery-form
    :initDelivery="initDelivery"
    :successMsg="t('created')"
    :submitAction="submit"
    enableClearForm
    clearFormOnSubmit
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import DeliveryForm from '@/views/companies/deliveries/DeliveryForm.vue'

import Delivery from '@/models/delivery/Delivery'
import { useI18n } from 'vue-i18n'

export default defineComponent({
  name: 'new-delivery',

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          created: 'Delivery company was created successfully'
        },
        ar: {
          created: 'تم انشاء شركة التوصيل بنجاح'
        }
      }
    })

    return { t }
  },

  components: {
    DeliveryForm
  },
  data() {
    return {
      initDelivery: new Delivery()
    }
  },

  methods: {
    async submit(delivery: Delivery) {
      try {
        await this.$http.post(Delivery.ENDPOINT, delivery)
        await this.$router.push(this.$Route.DELIVERIES)
      } catch (error) {
        return error
      }
    }
  }
})
</script>

<style></style>
